import { render, staticRenderFns } from "./scrollbar.vue?vue&type=template&id=4060cf30&"
import script from "./scrollbar.vue?vue&type=script&lang=js&"
export * from "./scrollbar.vue?vue&type=script&lang=js&"
import style0 from "./scrollbar.vue?vue&type=style&index=0&id=4060cf30&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports